export enum ContractType {
	BAV = 'BAV',
	BKV = 'BKV',
	BBU = 'BBU',
}
